import React from 'react';

import { pdiIcons } from 'pages/PDI/utils';

import * as S from './styles';

const KnowlageLevels = () => (
  <S.Container>
    <S.CardHead>Níveis de conhecimento</S.CardHead>
    <S.CardItem>
      {pdiIcons('noKnowledge')}
      <S.KnowleadgeDescription>
        <span>Nenhum:</span> Não conheço a tecnologia ou a ferramenta.
      </S.KnowleadgeDescription>
    </S.CardItem>
    <S.CardItem>
      {pdiIcons('theoricalKnowledge')}
      <S.KnowleadgeDescription>
        <span>Teórico:</span> Já li ou fiz curso, mas nunca pratiquei.
      </S.KnowleadgeDescription>
    </S.CardItem>
    <S.CardItem>
      {pdiIcons('pontualKnowledge')}
      <S.KnowleadgeDescription>
        <span>Uso pontual:</span> Usei em algum projeto, porém não no dia a dia.
      </S.KnowleadgeDescription>
    </S.CardItem>
    <S.CardItem>
      {pdiIcons('dailyKnowledge')}
      <S.KnowleadgeDescription>
        <span>Uso cotidiano:</span> Uso ou já usei no meu dia-a-dia e não tenho
        impedimentos para utilização.
      </S.KnowleadgeDescription>
    </S.CardItem>
    <S.CardItem>
      {pdiIcons('domainKnowledge')}
      <S.KnowleadgeDescription>
        <span>Domínio pleno:</span> Tenho domínio e consigo aplicar de modo
        adequado.
      </S.KnowleadgeDescription>
    </S.CardItem>
    <S.CardItem>
      {pdiIcons('referenceKnowledge')}
      <S.KnowleadgeDescription>
        <span>Referência técnica:</span> Tenho expertise e sou acionado
        constantemente pelo time sobre o assunto.
      </S.KnowleadgeDescription>
    </S.CardItem>
  </S.Container>
);

export default KnowlageLevels;
